<template>
  <div class="live-condition-setting">
    <div class="condition-setting">
      <div class="condition-setting_form">
        <vh-form :model="conditionForm" label-width="140px" onsubmit="return false;">
          <vh-form-item :label="$t('host.k_563001')">
            <vh-radio-group
              v-model="conditionForm.lottery_type"
              :style="{ width: $i18n.locale == 'en' ? '650px' : '550px' }"
            >
              <vh-radio :label="1">{{ $t('host.k_563002') }}</vh-radio>
              <vh-radio :label="3" :disabled="configList['ui.hide_sign_in'] == 0">
                {{ $t('host.k_563003') }}
                <span class="color_red" v-if="configList['ui.hide_sign_in'] == 0">
                  {{ $t('host.k_563004') }}
                </span>
              </vh-radio>
              <vh-radio :label="2" :disabled="configList['ui.hide_survey'] == 0">
                {{ $t('host.k_563005') }}
                <span
                  class="condition-setting_set can_view"
                  @click="goQuestionSetting"
                  v-if="configList['ui.hide_survey'] == 1"
                >
                  {{ $t('host.k_563006') }}
                </span>
                <span class="color_red" v-else>{{ $t('host.k_563004') }}</span>
              </vh-radio>
              <vh-radio :label="8" class="condition-setting_code">
                {{ $t('host.k_563007') }}
              </vh-radio>
              <vh-radio :label="21" :disabled="configList['exam'] == 0">
                {{ $t('host.k_563008') }}
                <span
                  class="condition-setting_set can_view"
                  @click="goExamSetting"
                  v-if="configList['exam'] == 1"
                >
                  {{ $t('host.k_563006') }}
                </span>
                <span class="color_red" v-else>{{ $t('host.k_563004') }}</span>
              </vh-radio>
              <div class="condition_code" v-if="conditionForm.lottery_type == 8">
                <vh-input
                  v-model="conditionForm.lottery_code"
                  type="text"
                  maxlength="15"
                  show-word-limit
                  :placeholder="$t('host.k_563009')"
                  style="width: 390px"
                ></vh-input>
              </div>
            </vh-radio-group>
          </vh-form-item>
          <vh-form-item
            :label="$t('host.k_563010')"
            v-if="[2, 3, 21].includes(conditionForm.lottery_type)"
          >
            <vh-radio v-model="conditionForm.lottery_tips" :label="0">
              {{ $t('host.k_563011') }}
            </vh-radio>
            <vh-radio v-model="conditionForm.lottery_tips" :label="1">
              {{ $t('host.k_563012') }}
              <span class="condition-setting_set example-title">
                {{ $t('host.k_563013') }}
                <span class="example-preview">
                  <img src="../../img/lottery_preview.png" alt="" />
                </span>
              </span>
            </vh-radio>
          </vh-form-item>
          <vh-form-item :label="$t('host.k_563014')">
            <p>
              {{ $t('host.k_563015') }}
              <span class="condition-setting_set set_audience" @click="settingAudience">
                {{ $t('host.k_563006') }}
              </span>
            </p>

            <template v-if="lotteryWinList.length">
              <p class="set_user">{{ $t('host.k_563016') }}</p>
              <div class="set_list">
                <div class="set_list_item" v-for="item in lotteryWinList" :key="item.key">
                  <p>{{ item.subject }}</p>
                  <span v-show="item.type == 'group'">({{ item.num }}人)</span>
                  <span @click="removeWinList(item)">
                    <i class="vh-iconfont vh-line-close"></i>
                  </span>
                </div>
              </div>
            </template>
            <template v-if="lotteryBlackList.length">
              <p class="set_user">{{ $t('host.k_563018') }}</p>
              <div class="set_list">
                <div class="set_list_item" v-for="item in lotteryBlackList" :key="item.key">
                  <p>{{ item.subject }}</p>
                  <span v-show="item.type == 'group'">({{ item.num }}人)</span>
                  <span @click="removeBlackList(item)">
                    <i class="vh-iconfont vh-line-close"></i>
                  </span>
                </div>
              </div>
            </template>
          </vh-form-item>
          <vh-form-item :label="$t('host.k_563019')">
            <vh-checkbox v-model="conditionForm.lottery_repeat">
              {{ $t('host.k_563020') }}
            </vh-checkbox>
            <br />
            <vh-checkbox v-model="conditionForm.can_remaining_lottery">
              {{ $t('host.k_563021') }}
            </vh-checkbox>
            <br />
            <vh-checkbox v-model="conditionForm.lottery_look">
              {{ $t('host.k_563022') }}
            </vh-checkbox>
            <br />
            <vh-checkbox v-model="conditionForm.can_block_overseas">
              {{ $t('host.k_563023') }}
            </vh-checkbox>
          </vh-form-item>
        </vh-form>
      </div>
      <div class="condition-setting_btn">
        <vh-button type="primary" round @click="sureConditionInfo" v-preventReClick>
          {{ $t('host.k_563024') }}
        </vh-button>
      </div>
    </div>
    <setting-question
      ref="settingQuestion"
      :readOnly="readOnly"
      @selectQuestion="selectQuestion"
    ></setting-question>
    <setting-exam ref="settingExamDom" :readOnly="readOnly" @selectExam="selectExam"></setting-exam>
    <setting-audience ref="settingAudience" @selectAudience="selectAudience"></setting-audience>
  </div>
</template>
<script>
  import settingQuestion from '../dialogs/setting-question.vue';
  import settingExam from '../dialogs/setting-exam.vue';
  import settingAudience from '../dialogs/setting-audience.vue';
  import { useLotteryServer, useRoomBaseServer } from 'middle-domain';
  export default {
    data() {
      return {
        conditionForm: {
          lottery_type: 1,
          lottery_tips: 0,
          lottery_code: '',
          lottery_repeat: false,
          can_remaining_lottery: false,
          lottery_look: false,
          can_block_overseas: false
        },
        lotteryWinList: [],
        lotteryBlackList: [],
        lottery_question: {
          type: 1,
          survey_list: []
        },
        lottery_qa: {
          type: 1,
          score: '',
          fqa_list: []
        }
      };
    },
    props: {
      readOnly: {
        type: Boolean,
        default: false
      }
    },
    components: {
      settingQuestion,
      settingExam,
      settingAudience
    },
    computed: {
      lotteryId() {
        return this.lotteryServer.state.lotteryLiveId;
      }
    },
    beforeCreate() {
      this.lotteryServer = useLotteryServer({
        mode: 'live'
      });
    },
    created() {
      const { configList } = useRoomBaseServer().state;
      this.configList = configList;
      // this.initComponent();
    },
    methods: {
      initComponent() {
        if (this.lotteryId) {
          this.getConditionInfo();
        }
      },
      // 获取设置信息
      getConditionInfo() {
        this.lotteryServer.getConditionLiveInfo().then(res => {
          if (res.code === 200 && res.data) {
            this.conditionForm.lottery_type = res.data.lottery_type;
            this.conditionForm.lottery_look = Boolean(res.data.can_look_winner_list);
            this.conditionForm.can_block_overseas = Boolean(res.data.can_block_overseas);
            this.conditionForm.lottery_repeat = Boolean(res.data.can_repeat_lottery);
            this.conditionForm.can_remaining_lottery = Boolean(res.data.can_remaining_lottery);
            this.conditionForm.lottery_tips = res.data.show_discontent_tips;
            const user_setting = res.data.user_setting && JSON.parse(res.data.user_setting);
            const winList = user_setting?.lottery_user_pool_list || [];
            const blackList = user_setting?.lottery_black_list || [];
            this.lotteryWinList =
              (winList.length &&
                winList.map(item => {
                  if (item.type == 2) {
                    return {
                      subject: item.name,
                      key: item.id,
                      num: item.num,
                      type: 'group'
                    };
                  } else {
                    return {
                      subject: item.name,
                      key: item.id,
                      label: item.name,
                      num: 0,
                      type: 'user'
                    };
                  }
                })) ||
              [];
            this.lotteryBlackList =
              (blackList.length &&
                blackList.map(item => {
                  if (item.type == 2) {
                    return {
                      subject: item.name,
                      key: item.id,
                      num: item.num,
                      type: 'group'
                    };
                  } else {
                    return {
                      subject: item.name,
                      key: item.id,
                      label: item.name,
                      num: 0,
                      type: 'user'
                    };
                  }
                })) ||
              [];
            const conditionInfo =
              res.data.lottery_condition && JSON.parse(res.data.lottery_condition);
            // 口令抽奖
            if (res.data.lottery_type == 8) {
              this.conditionForm.lottery_code = conditionInfo.command;
            }
            // 问卷
            if (res.data.lottery_type == 2) {
              this.lottery_question = conditionInfo;
            }
            // 问答
            if (res.data.lottery_type == 21) {
              this.lottery_qa = conditionInfo;
            }
          }
        });
      },
      // 保存条件设置
      sureConditionInfo() {
        if (this.conditionForm.can_remaining_lottery) {
          const hasUser = (this.lotteryWinList || []).findIndex(item => item.type === 'user') > -1;
          /* prettier-ignore */
          const groupHasUser = (this.lotteryWinList || []).findIndex(item => item.type === 'group' && item.num > 0) > -1;
          if ((this.lotteryWinList || []).length < 1 || !(hasUser || groupHasUser)) {
            this.$vhAlert(this.$t('host.k_563030'), this.$t('host.k_608019'), {
              confirmButtonText: this.$t('host.k_608020'),
              customClass: 'zdy-message-box',
              callback: action => {}
            });
            return;
          }
        }
        let params = {
          lottery_type: this.conditionForm.lottery_type,
          show_discontent_tips: this.conditionForm.lottery_tips,
          can_repeat_lottery: Number(this.conditionForm.lottery_repeat),
          can_remaining_lottery: Number(this.conditionForm.can_remaining_lottery),
          can_look_winner_list: Number(this.conditionForm.lottery_look),
          can_block_overseas: Number(this.conditionForm.can_block_overseas),
          lottery_condition: null
        };
        // 口令
        if (this.conditionForm.lottery_type == 8) {
          if (!this.conditionForm.lottery_code) {
            this.$message.error(this.$t('host.k_563025'));
            return;
          }
          let code = {
            command: this.conditionForm.lottery_code
          };
          params.lottery_condition = JSON.stringify(code);
        }
        // 问卷
        if (this.conditionForm.lottery_type == 2) {
          if (this.lottery_question.type == 3 && !this.lottery_question.survey_list.length) {
            this.$message.error(this.$t('host.k_563026'));
            return;
          }
          params.lottery_condition = JSON.stringify(this.lottery_question);
        }
        // 问答
        if (this.conditionForm.lottery_type == 21) {
          if (!this.lottery_qa.fqa_list.length) {
            this.$message.error(this.$t('host.k_563027'));
            return;
          }
          params.lottery_condition = JSON.stringify(this.lottery_qa);
        }
        const lotteryList = [...this.lotteryWinList, ...this.lotteryBlackList];
        if (lotteryList.length) {
          const groupList_win =
            this.lotteryWinList.filter(e => e.type == 'group').map(item => item.key) || [];
          const groupList_black =
            this.lotteryBlackList.filter(e => e.type == 'group').map(item => item.key) || [];
          const userList_win =
            this.lotteryWinList.filter(e => e.type == 'user').map(item => item.key) || [];
          const userList_black =
            this.lotteryBlackList.filter(e => e.type == 'user').map(item => item.key) || [];
          let lottery_user_pools = [];
          let lottery_black_list = [];
          //type:2-观众组,3在线用户
          groupList_win.map(e => {
            lottery_user_pools.push({
              id: e,
              type: 2
            });
          });
          groupList_black.map(e => {
            lottery_black_list.push({
              id: e,
              type: 2
            });
          });
          userList_win.map(e => {
            lottery_user_pools.push({
              id: e,
              type: 3
            });
          });
          userList_black.map(e => {
            lottery_black_list.push({
              id: e,
              type: 3
            });
          });
          const list = {
            lottery_user_pool_list: lottery_user_pools,
            lottery_black_list: lottery_black_list
          };
          params.user_setting = JSON.stringify(list);
        }
        this.lotteryServer.saveConditionLiveInfo(params).then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('host.k_563028'));
            this.$emit('success', { type: 'condition', act: 'save' });
            // this.returnStep('reward');
          } else {
            this.$message.error(res.msg);
          }
        });
      },
      // 问卷
      selectQuestion(info) {
        this.lottery_question = info;
      },
      // 快问快答
      selectExam(info) {
        this.lottery_qa = info;
        console.log(info);
      },
      // 观众组选择
      selectAudience(winList, list) {
        this.lotteryWinList = winList;
        this.lotteryBlackList = list;
        console.log(this.lotteryWinList, this.lotteryBlackList, '???');
      },
      removeWinList(item) {
        this.lotteryWinList.splice(this.lotteryWinList.indexOf(item), 1);
      },
      removeBlackList(item) {
        this.lotteryBlackList.splice(this.lotteryBlackList.indexOf(item), 1);
      },
      // 返回列表
      returnStep(name) {
        this.$emit('returnStep', name);
      },
      // 导入用户
      showImportUser() {
        if (this.configList['white_list'] != 1) {
          return;
        }
        let url = window.location.origin + process.env.VUE_APP_ROUTER_BASE_URL + '/setting/viewer';
        window.open(url, '_blank');
      },
      // 设置问卷
      goQuestionSetting(e) {
        if (this.readOnly) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (this.configList['exam'] != 1) {
          this.$message.error(this.$t('host.k_563029'));
          return;
        }
        this.$refs.settingQuestion.openSettingDialog(this.lotteryId, this.lottery_question);
      },
      // 设置快问快答
      async goExamSetting(e) {
        if (this.readOnly) {
          e.preventDefault();
          e.stopPropagation();
        }
        if (this.configList['ui.hide_survey'] != 1) {
          this.$message.error(this.$t('host.k_563029'));
          return;
        }
        this.$refs.settingExamDom &&
          this.$refs.settingExamDom.open(this.lotteryId, this.lottery_qa);
      },
      // 设置观众组
      async settingAudience() {
        this.$refs.settingAudience.openSettingAudience(this.lotteryWinList, this.lotteryBlackList);
      }
    }
  };
</script>
<style lang="less">
  .live-condition-setting {
    min-height: 500px;
    .vh-form-item__label {
      color: #1a1a1a;
    }
    .vh-radio,
    .vh-radio__input.is-checked + .vh-radio__label {
      color: #1a1a1a;
      line-height: 40px;
    }
    .vh-radio__label,
    .vh-checkbox__label {
      color: rgba(0, 0, 0, 0.65);
    }
    .vh-checkbox,
    .vh-checkbox__input.is-checked + .vh-checkbox__label {
      color: #1a1a1a;
      font-weight: normal;
    }
    .condition-setting {
      &_form {
        width: 655px;
      }
      &_set {
        color: #3562fa;
        padding: 0 10px;
        font-size: 14px;
        cursor: pointer;
        &.can_view {
          position: relative;
          z-index: 20;
        }
      }
      &_code {
        margin-right: 38px;
      }
      .set_audience {
        padding: 0 4px 0 0;
      }
      .set_user {
        color: rgba(0, 0, 0, 0.85);
        line-height: 36px;
      }
      .set_list {
        max-height: 160px;
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        &_item {
          background: #f0f0f0;
          border-radius: 4px;
          padding: 0 12px;
          height: 30px;
          line-height: 30px;
          display: flex;
          justify-content: space-between;
          font-size: 14px;
          &:hover {
            p {
              color: #fb3a32;
            }
            span {
              color: #fb3a32;
            }
          }
          p {
            max-width: 180px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            color: #595959;
            padding-right: 5px;
          }
          span {
            color: #595959;
            i {
              padding-left: 5px;
              font-size: 12px;
              cursor: pointer;
            }
          }
        }
      }
      &_btn {
        margin: auto;
        text-align: left;
        color: #fb3a32;
        margin-left: 140px;
        padding-top: 8px;
      }
      .color_red {
        color: #fb3a32;
      }
      .example-title {
        position: relative;
        .example-preview {
          visibility: hidden;
          position: absolute;
          right: -150px;
          top: 0;
          width: 151px;
          height: 277px;
          z-index: 2;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &:hover {
          .example-preview {
            visibility: visible;
          }
        }
      }
    }
  }
</style>
